export const coreWalletPaymentTransactionStatusForSelection = [
	'Created',
	'Pending',
	'Success',
	'Failure',
	'Unknown',
	'FailureBeforeExecution'
].map(status => {
	return {
		id: status,
		name: status
	};
});

export const coreWalletPaymentTransactionTypesForSelection = [
	'Preauthorization',
	'Reversal',
	'Capture',
	'Authorization',
	'Credit',
	'Refund',
	'ExternalPayment'
].map(status => {
	return {
		id: status,
		name: status
	};
});
